import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { useSampleData } from '../../../../components/UseSampleData.js';
import { useAppSelector } from '../../../../hooks/hooks.js';
import { selectMode } from '../../../../store/reducers/enginePropertiesSlice.js';
import './C2Chart.css.js';
import C2ChartChild from './C2ChartChild.js';
import './C2Charts.css.js';
import './highcharts.css.js';
import { getDefaultItems, getDefaultColumns } from './defaultData.js';

const C2Chart = (_a) => {
    var _b, _c;
    var { className, dataColumns = [], dataItems = [], loading, onLoad, chartVisualSqlQuery, chartType } = _a, otherProps = __rest(_a, ["className", "dataColumns", "dataItems", "loading", "onLoad", "chartVisualSqlQuery", "chartType"]);
    const mode = useAppSelector(selectMode);
    const id = ((_b = otherProps.id) === null || _b === void 0 ? void 0 : _b.startsWith("cmp-")) ? otherProps.id.substring(4) : otherProps.id;
    const sample = useSampleData(id);
    const { dataSource } = otherProps;
    const isLoading = mode === "design" ? sample.isLoading : loading;
    const items = !dataSource ? getDefaultItems(chartType) : mode === "design" ? (_c = sample.data) !== null && _c !== void 0 ? _c : [] : dataItems !== null && dataItems !== void 0 ? dataItems : [];
    const columns = !dataSource ? getDefaultColumns(chartType) : dataColumns !== null && dataColumns !== void 0 ? dataColumns : [];
    return (React.createElement(C2ChartChild, Object.assign({}, otherProps, { dataItems: items, className: className, dataColumns: columns, loading: isLoading, onLoad: onLoad, chartVisualSqlQuery: chartVisualSqlQuery, chartType: chartType })));
};

export { C2Chart as default };
//# sourceMappingURL=C2Chart.js.map
